import { useEffect } from "react";

import { UPDATE_PRODUCT_PRICES_LOCALLY } from "@/redux/types/product.types";

const updateProductPricesCollection = (productsCollection, eventDetail) => {
	if (!Array.isArray(productsCollection) || productsCollection.length === 0) {
		return { hasAnyChange: false, updatedProducts: productsCollection };
	}

	if (!eventDetail?.productId && !eventDetail?.productCode) {
		return { hasAnyChange: false, updatedProducts: productsCollection };
	}

	const normalizedEstateParentId = String(eventDetail.estateParentId || "");
	const normalizedCurrency = String(eventDetail.currency || "").toUpperCase();
	const normalizedPrice = Number(eventDetail.price);

	if (Number.isNaN(normalizedPrice)) {
		return { hasAnyChange: false, updatedProducts: productsCollection };
	}

	let hasAnyChange = false;

	const updatedProducts = productsCollection.map((productItem) => {
		const hasSameId = Number(productItem.id) === Number(eventDetail.productId);
		const hasSameCode = String(productItem.code || "") === String(eventDetail.productCode || "");
		if (!hasSameId && !hasSameCode) return productItem;

		const currentPrices = Array.isArray(productItem.prices) ? [...productItem.prices] : [];
		const targetPriceIndex = currentPrices.findIndex((priceItem) => String(priceItem.estate_parent_id || "") === normalizedEstateParentId);
		const targetPriceItem = targetPriceIndex >= 0 ? { ...currentPrices[targetPriceIndex] } : { estate_parent_id: normalizedEstateParentId };

		if (normalizedCurrency === "USD") {
			targetPriceItem.price_usd = normalizedPrice;
		} else {
			targetPriceItem.price = normalizedPrice;
		}

		targetPriceItem.is_manual = true;

		if (targetPriceIndex >= 0) {
			currentPrices[targetPriceIndex] = targetPriceItem;
		} else {
			currentPrices.push(targetPriceItem);
		}

		hasAnyChange = true;
		return { ...productItem, prices: currentPrices };
	});

	return { hasAnyChange, updatedProducts };
};

const useLegacyProductPriceSync = ({ products, dispatch }) => {
	useEffect(() => {
		const handlePriceUpdated = (event) => {
			const { hasAnyChange, updatedProducts } = updateProductPricesCollection(products, event?.detail);
			if (!hasAnyChange) return;

			dispatch({
				type: UPDATE_PRODUCT_PRICES_LOCALLY,
				payload: {
					products: updatedProducts,
				},
			});
		};

		globalThis.addEventListener("product-price-updated", handlePriceUpdated);
		return () => {
			globalThis.removeEventListener("product-price-updated", handlePriceUpdated);
		};
	}, [products, dispatch]);
};

export default useLegacyProductPriceSync;
